export enum PartTreeActionType {
  FETCH_TREE = "FETCH_TREE",
  FETCH_TREE_START = "FETCH_TREE_START",
  FETCH_TREE_SUCCESS = "FETCH_TREE_SUCCESS",
  FETCH_TREE_FAIL = "FETCH_TREE_FAIL"
}
